import { render } from "./StorySlider.vue?vue&type=template&id=792c566d&scoped=true"
import script from "./StorySlider.vue?vue&type=script&lang=js"
export * from "./StorySlider.vue?vue&type=script&lang=js"

import "./StorySlider.vue?vue&type=style&index=0&id=792c566d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792c566d"]])

export default __exports__